'use client';

import * as React from 'react';
import { SkeletonContent } from '@/shared/components/skeletons';

/**
 * @useClient
 */
export default function Loading() {
  return <SkeletonContent data-sentry-element="SkeletonContent" data-sentry-component="Loading" data-sentry-source-file="loading.tsx" />;
}